/**
 * Event class for QueryCache lifecycle events.
 *
 * This class represents events that track the various operations performed
 * on the QueryCache, providing type-safe event data and cache key tracking.
 *
 * @template TData - The type of data associated with this event
 */
export class QueryCacheEvent {
    type;
    key;
    data;
    /**
     * Creates a new QueryCache event.
     *
     * @param type - The specific event type identifier
     * @param key - The cache key associated with this event
     * @param data - Optional event-specific data payload
     */
    constructor(type, key, data) {
        this.type = type;
        this.key = key;
        this.data = data;
    }
}
//# sourceMappingURL=QueryCacheEvent.js.map